import './QuantitativeSampleEditForm.css';

import React, { useContext, useState } from "react";
import B2BFormContainer from "../../../b2b-common/B2BFormContainer";
import { B2BDatePicker } from "../dates/DatesRangeEditor";
import { LoginContext } from "../../../../App";
import EditText from "../../../b2b-common/EditText";
import { deleteSample, saveNewSample, updateSample } from '../../../../services/b2b-plans-apiService';
import { B2BContentContext } from '../../../layout/Layout';
import { showNotification } from '../../../b2b-common/Notification';
import { generateSelectField } from '../../../b2b-common/helpers';
import { getValuesFromDimensionalType } from '../helper';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const QuantitativeSampleEditForm = ({ sample, planUUID, areaId, areaIndicatorId, indicator = null,
    disabledDateRanges = [],
    onCancel, onSave, onDelete }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const { loginData } = useContext(LoginContext);
    const { setNotification } = useContext(B2BContentContext);
    const [error, setError] = useState(null);

    const initialQuantitativeSample = {
        "sampleType": "QUANTITATIVE",
        "sampleDate": null,
        "quantitativeValue": 0,
    };

    const [currentSample, setCurrentSample] = useState(sample ? sample : initialQuantitativeSample);
    const [currentDimensionalType, setCurrentDimensionalType] = useState(null);
    const [currentDimensionalValue, setCurrentDimensionalValue] = useState(null);

    const handleSave = async () => {
        if (sample === null) {
            // create new sample
            const newSample = { ...currentSample, sampleId: 0 };
            try {
                const savedSample = await saveNewSample(loginData.accessToken, planUUID, areaId, areaIndicatorId, newSample);
                showNotification(setNotification, t('Sample created'), 'success', 3000);
                onSave && onSave(savedSample);
            } catch (error) {
                setError(error);
                console.error(t('Error saving new sample:'), error);
                showNotification(setNotification, t('Error saving new sample:') + ' ' + error.message, 'error', 3000);
            }
        } else {
            // update existing sample
            try {
                const updatedSample = await updateSample(loginData.accessToken, planUUID, areaId, areaIndicatorId, sample.sampleId, currentSample);
                showNotification(setNotification, t('Sample updated'), 'success', 3000);
                onSave && onSave(updatedSample);
            } catch (error) {
                setError(error);
                console.error(t('Error updating sample:'), error);
                showNotification(setNotification, t('Error updating sample:') + ' ' + error.message, 'error', 3000);
            }
        }
    };

    const handleDelete = async () => {
        try {
            await deleteSample(loginData.accessToken, planUUID, areaId, areaIndicatorId, sample.sampleId);
            showNotification(setNotification, t('Sample deleted'), 'success', 3000);
            onDelete && onDelete(sample);
        } catch (error) {
            setError(error);
            console.error(t('Error deleting sample:'), error);
            showNotification(setNotification, t('Error deleting sample:') + ' ' + error.message, 'error', 3000);
        }
    };

    const handleCancel = () => {
        onCancel && onCancel();
    };

    const handleDimensionChange = (event) => {
        const dimensionOrder = parseInt(event.target.value);
        const dimensionValue = currentDimensionalType.dimensionValues.find(dv => dv.quantitativeDimensionOrder === dimensionOrder);
        if (dimensionValue) {
            setCurrentDimensionalValue(dimensionValue);
            setCurrentSample({
                ...currentSample, quantitativeDimensionOrder: dimensionOrder
            });
        }
    };

    const measurementUnit = indicator ? indicator.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit : '';
    return (
        <B2BFormContainer title={t('Sample data')}
            buttonsConfig={[
                { label: t('Save'), onClick: handleSave },
                ...(sample && sample.sampleId > 0 ? [{ label: t('Delete'), onClick: handleDelete }] : []),
                { label: t('Cancel'), className: 'b2b-button-cancel white_03', onClick: handleCancel }
            ]}
            className='quantitative-sample-edit-form b2b-form-01'>
            <div className='quantitative-sample-edit-form-date'>
                <B2BDatePicker
                    objectHoldingDate={currentSample}
                    setObjectHoldingDate={setCurrentSample}
                    objectDateField='sampleDate'
                    label={t('Sample Date')}
                    value={currentSample.sampleDate}
                    disabledDateRanges={disabledDateRanges}
                    className={'quantitative-sample-edit-form-date'}
                    showTime={true}
                    readOnly={sample && sample.sampleId > 0}
                />
            </div>
            {currentDimensionalType &&
                generateSelectField(getValuesFromDimensionalType(currentDimensionalType),
                    {
                        label: currentDimensionalType ?
                            t(currentDimensionalType.dimensionTypeName) : "",
                        onChange: handleDimensionChange,
                        value: currentDimensionalValue ? currentDimensionalValue.quantitativeDimensionOrder : 0,
                        className: 'objective-edit-form-obj-dimension'
                    })}
            <div className='quantitative-sample-edit-form-value'>
                <EditText object={currentSample} objectField={'quantitativeValue'} setObjectField={setCurrentSample} label={t('Sample value')} className={'quantitative-sample-edit-form-value'} suffix={measurementUnit} />
            </div>
        </B2BFormContainer>
    );
};

export default QuantitativeSampleEditForm;